// Small marks the boards draw in several places.
import { Link } from '../lib/router.jsx'

// "Adam Slee · Members", the shell's wordmark
export function Wordmark({ to = '/', className = 'mark' }) {
  return (
    <Link to={to} className={className}>
      <span className="mark-name">Adam Slee</span>
      <span className="mark-dot" aria-hidden="true" />
      <span className="mark-sub">Members</span>
    </Link>
  )
}

// Property Cashflow For Life's pentagon, with its first side lit
export function Pentagon({ size = 24, stroke = 1.5, lit = 2.5 }) {
  return (
    <svg className="pentagon" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <polygon className="pentagon-edge" points="12,2.5 21.51,9.41 17.88,20.59 6.12,20.59 2.49,9.41" style={{ strokeWidth: stroke }} />
      <path className="pentagon-lit" d="M12 2.5 21.51 9.41" style={{ strokeWidth: lit }} />
    </svg>
  )
}

export function Arrow() {
  return (
    <svg className="icon-arrow" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  )
}

export function SearchIcon({ size = 18 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ strokeWidth: 2 }}>
      <circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" />
    </svg>
  )
}

export function BellIcon({ size = 20 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ strokeWidth: 1.75 }}>
      <path d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    </svg>
  )
}

export function CloseIcon() {
  return (
    <svg className="icon-line" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" style={{ strokeWidth: 2 }}>
      <path d="M18 6 6 18M6 6l12 12" />
    </svg>
  )
}

export function CardIcon() {
  return (
    <svg className="icon-line" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" style={{ strokeWidth: 1.75, flexShrink: 0 }}>
      <rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20" />
    </svg>
  )
}

export function LockIcon({ size = 26 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ strokeWidth: 1.75 }}>
      <rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  )
}

// A row's arrow buttons: left (back) or right (on)
export function SideChevron({ dir = 'on', size = 18 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ strokeWidth: 2 }}>
      <path d={dir === 'back' ? 'm15 18-6-6 6-6' : 'm9 18 6-6-6-6'} />
    </svg>
  )
}
